import { createContext } from 'react';

export const LicensePlateAndVinStepContext = createContext({
  isHistoryTrendUp: null,
  isHistoryTrendLoading: false,
  isNoTmvData: false,
});
